import { useApiContext } from '@customink/project-service-react-components';

import { useAuth } from '@/contexts/auth/AuthContext';

export const useGetCustomer = () => {
  const api = useApiContext();
  const { personalAccount } = useAuth();
  return api.useGetAccountTaxExemptionCustomerQuery(
    { accountId: personalAccount?.id as string },
    { skip: !personalAccount?.id },
  );
};
